import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { TApiSubset } from '../../api/endpoints/Subset';
import { TApiSubsetOptions } from '../../api/endpoints/SubsetOption';
import { Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router';
import SubsetOptionsSelect from './SubsetOptionsSelect';
import SubsetSelect from './SubsetSelect';
import { IProductFormValues } from './ProductForm';
import { Card, Col, Row } from "react-bootstrap";
import ConfigurationPreview from "./ConfigurationPreview";
import { FormikProps } from "formik";
import { TApiParameter } from "../../api/endpoints/Parameter";
import queryString from 'query-string'

interface IProps {
  actions?: (subset: TApiSubset, subsetOptions: TApiSubsetOptions, formik: FormikProps<IProductFormValues>) => ReactNode;
}

const subsetOptionsFormUrl = (currentUrl: string, subset: TApiSubset, params: Array<TApiParameter>) => {
  const query = queryString.stringify({
    params: params.map(p => p.shortname)
  })

  return [`${currentUrl}/subset/${subset.id}`, query].join('?');
}

const RealtimeProductConfigurator = (props: IProps) => {
  const { actions } = props;
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();

  const currentUrl = match.url;

  const [productFormValues, setProductFormValues] = useState<IProductFormValues | null>(null);
  const [currentSubset, setCurrentSubset] = useState<TApiSubset | null>(null);

  useEffect(() => {
    setProductFormValues(null);
  }, [location.pathname])

  const onSubsetChange = useCallback((subset: TApiSubset, params: Array<TApiParameter>) => {
    history.push(subsetOptionsFormUrl(currentUrl, subset, params));
    setCurrentSubset(subset);
  }, [history, currentUrl]);

  const onProductValuesChange = useCallback((values: IProductFormValues) => {
    setProductFormValues(values)
  }, []);

  return (
    <div className="product-configurator">
      <Switch>
        <Route path={currentUrl} exact>
          <SubsetSelect onChange={onSubsetChange} />
        </Route>

        <Route path={currentUrl + "/subset/:subsetId"} exact>
          <Row>
            <Col xs={12} sm={12} md={8}>
              <SubsetOptionsSelect
                onChange={onProductValuesChange}
                actions={actions}
              />
            </Col>

            <Col md={4}>
              <Card className="product-configurator-preview">
                <Card.Body>
                  {
                    <ConfigurationPreview
                      subset={currentSubset}
                      values={productFormValues}
                    />
                  }
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Route>
      </Switch>
    </div>
  );
};

export default RealtimeProductConfigurator;
